import React from 'react';
import { event } from '@uhg-abyss/web/tools/event';
import { IconFeedback } from '../IconFeedback/IconFeedback';
import { SideTab } from '../SideTab';

export const FeedbackTab = () => {
  const handleClick = () => {
    event('FEEDBACK');
  };
  return (
    <SideTab
      onClick={() => {
        return handleClick();
      }}
      variant="outline"
      before={<IconFeedback size={16} color="$primary1" />}
      offset={530}
    >
      Feedback
    </SideTab>
  );
};
